const styles = () => {
  return {
    anchorRoot: {
      width: '1rem',
      height: '1rem',
    },
    down: { transform: 'rotate(0deg)' },
    up: { transform: 'rotate(180deg)' },
    left: { transform: 'rotate(90deg)' },
    right: { transform: 'rotate(270deg)' },
  };
};

export default styles;
